import { DataProcessingValidationSchema } from "@lib/validation-schema/dataProcessingValidation";
import { IApprovalRequestInfo } from "./approvalRequestDefinitions";
import { ApprovalRequestInfoSchema } from "@lib/definitions";
import { FormState } from "./definitions";

interface IDataProcessingItem {
    id: number;
    name: string;
    clientCode: string;
    isDraftClient: boolean;
    clientName: string;
    dataProcessingRules: IDataProcessingRuleItem[];
    processorCode: string;
    processorName?: string;
    status: string;
    statusName?: string;
    approvalRequestId?: number
    isRequestPublish: boolean;
    isDraft: boolean;
    programSplitRuleMappings: IDataProcessingProgramSplitRuleItem[];
    approvalRequestInfo?: IApprovalRequestInfo;
    coStatusName?: string;
}

interface IDataProcessingClientItem {
    id: number;
    clientCode: string;
    clientName: string;
    isDraft: boolean;
}

interface IDataProcessingRuleItem {
    id?: number;
    name: string;
    dataProcessingId?: number;
}

interface IDataProcessingProgramSplitRuleItem {
    id: number;
    dataStreamSelects: string[] | null;
    dataProcessingId?: number;
    conditions: IDataProcessingProgramSplitConditionItem[] | null;
    elseProgramCode: string | null;
    hasProgram?: boolean | null;
    index: number;
}

interface IDataProcessingProgramSplitConditionItem {
    id: number;
    fieldId: number | null;
    otherFieldName: string | null;
    operator: string | null;
    fieldValue: string | null;
    fieldValue1: string | null;
    fieldType: string | null;
    thenProgramCode: string | null;
    depth: number | null;
    parentProgramSplitRuleConditionId: number | null;
    innerConditions: IDataProcessingProgramSplitConditionItem[] | null;
    elseProgramCode: string | null;
    index: number;
}
export interface INewDataProcessingItem {
    id?: number;
    name?: string;
    clientCode?: string;
    processorCode?: string;
    createdBy?: string;
}
export type NewDataProcessingRuleFormState = FormState & {
    name?: string;
    clientCode?: string;
    processorCode?: string;
};
export const ValidateDataProcessing = (data?: IDataProcessingItem, isNew?: boolean) => {
    if (isNew && data) {
        data.id = 0;
    }
    return DataProcessingValidationSchema.safeParse(data);
};

const GOLDFIELDS = [
    { name: 'SoldDate (gold)', value: 'gold.account_aggregate_summary.SoldDate', type: 'datetime' },
    { name: 'Last Reload Date (gold)', value: 'gold.account_aggregate_summary.LastReloadDate', type: 'datetime' },
    { name: 'Last Use Date (gold)', value: 'gold.account_aggregate_summary.LastUseDate', type: 'datetime' },
    { name: 'First Use Date (gold)', value: 'gold.account_aggregate_summary.FirstUseDate', type: 'datetime' },
    { name: 'Calendar Month Sold (gold)', value: 'CalendarMonthSold' },
    { name: 'Sold Denomination (Sold Amount) (gold)', value: 'gold.account_aggregate_summary.SoldAmount', type: 'double' },
]

export type {
    IDataProcessingItem,
    IDataProcessingClientItem,
    IDataProcessingRuleItem,
    IDataProcessingProgramSplitRuleItem,
    IDataProcessingProgramSplitConditionItem,
}

export {
    GOLDFIELDS
}